import type { FC } from 'react';
import { Suspense, lazy } from 'react';
import WidgetConfigPopover from '@wix/da-gruser-shared/pkg/components/WidgetBox/lego/WidgetConfigPopover';

const FeedConfigPopover = lazy(
  () => import(/* webpackChunkName: "owner" */ '../../FeedConfigPopover')
);

type Props = any;

const FeedConfigPopoverLazy: FC<Props> = props => {
  return (
    <Suspense fallback={<WidgetConfigPopover isLoading onClose={() => null} />}>
      <FeedConfigPopover {...props} />
    </Suspense>
  );
};
FeedConfigPopoverLazy.displayName = 'FeedConfigPopoverLazy';

export default FeedConfigPopoverLazy;
